module.exports = __webpack_public_path__ + "static/media/Cloud-background.11452cab.png";